import { Crudable, ToolbarActionable } from "kinnect-mixins";
import {
	KActionDialog,
	KAddressMapDialog,
	KDataTable,
	KDataTableMenu,
	KPhoneLink
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "KCustomerAddressTable",

	mixins: [
		Crudable,
		ToolbarActionable
	],

	props: {
		hideToolbarButton: Boolean,

		idCustomer: Number,

		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no addresses to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching addresses found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "alias"
		}
	},

	data: () => ( {
		crud: "addresses"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Alias",
					value: "alias"
				},
				{
					text: "Address",
					value: "address.fullAddress"
				},
				{
					text: "Phone",
					value: "phone"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		},

		toolbarActions() {
			if ( !this.hideToolbarButton && this.canAdd ) {
				return {
					icon: "add_circle",
					text: "Add Address",
					to: {
						name: "customerAddressAdd",
						params: { idCustomer: this.idCustomer }
					},
					tooltip: "Add a new address for this customer"
				};
			}
		}
	},

	methods: {
		deleteAddress( address ) {
			const deleteIndex = this.items.findIndex( item => address.id === item.id );

			return address.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.address.fullAddress": ( { item } ) =>
					<KAddressMapDialog address={item}></KAddressMapDialog>,

				"item.phone": ( { item } ) => (
					item.phone
						? <KPhoneLink phone={item.phone}></KPhoneLink>
						: "--"
				),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "customerAddress",
								params: {
									idAddress: item.id,
									idCustomer: item.idCustomer
								}
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete address" )}
								onConfirm={() => this.deleteAddress( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Address"
							>
								Are you sure you want to delete the address <strong>{item.alias}</strong> at <strong>{item.address}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
